//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import useIncomingInvoiceSnoozeAction from "./useIncomingInvoiceSnoozeAction";
import useIncomingInvoiceForwardAction from "./useIncomingInvoiceForwardAction";
//#endregion

function useQuickActions(
  id: number | string,
  onActionSuccess: () => void,
  reloadHandler: (onSuccess?: (invoice: WintSuperkollAPIModel.IncomingInvoice) => void, onError?: () => void) => void
) {
  const snoozeAction = useIncomingInvoiceSnoozeAction(id, onActionSuccess);
  const forwardAction = useIncomingInvoiceForwardAction(id, reloadHandler);

  const quickActions: MoreActionMenuItem[] = [];
  quickActions.push(snoozeAction);
  quickActions.push(forwardAction);

  return quickActions;
}

export default useQuickActions;
